import { List } from 'immutable'
import React from 'react'
import { any, async, fromJSX, nothing } from 'widgets-for-react'
import { Updater } from 'widgets-for-react'
import { ViewListenerState } from '../viewListener/viewListenerState'
import { HeaderLayout } from './headerLayout'
import { HeaderItem, HeaderState, headerStateUpdaters } from './headerState'

export const headerWidget = (view: ViewListenerState) => (state: HeaderState) => {
  const headerDataState = state.headerItemsState
  return any<Updater<HeaderState>>([
    async<List<HeaderItem>>(state.headerItemsState).map(headerStateUpdaters.updateHeaderDataState),
    headerDataState.kind === 'loaded'
      ? fromJSX((setState) => { 
        //remove loader if not yet done
        const loaderEL = document.getElementById('app-loader');
        if(loaderEL != null) loaderEL.remove();

        return (
          <HeaderLayout
            items={headerDataState.value
              .map((item, index) => ({
                ...item,
                isItemOpen: item.opened,
                toggleItem: () => setState(headerStateUpdaters.updateItemOpened(index)),
              }))
              .toArray()}
            view={view}
            isMenuOpen={state.menuOpened}
            toggleMenu={() => setState(headerStateUpdaters.updateMenuOpened)}
          />
        )})
      : nothing(),
  ])
}
